import * as React from 'react';
import { VendorViewModel, VendorDocumentExpire } from '@models/Vendor';

export interface FileRemoveProps {
  readonly fileId: number;
  readonly filename: string;
  readonly vendorVm: VendorViewModel;
  readonly documentType: number;
  readonly isModal: boolean;
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly onSaveClick: (fileId: number, vendor: VendorViewModel) => void;
}

export class FileRemoveComponent extends React.Component<FileRemoveProps> {
  constructor(props: FileRemoveProps) {
    super(props);
    this.onSaveClick = this.onSaveClick.bind(this);
  }

  onSaveClick = () => {
    const { vendorVm, documentType } = this.props;
    const updatedVendor = { ...vendorVm };
    switch (documentType) {
      case VendorDocumentExpire.LiabilityExpiration:
        updatedVendor.liabilityExpiration = undefined;
        break;
      case VendorDocumentExpire.WorkersCompExpiration:
        updatedVendor.sdiExpiration = undefined;
        break;
      case VendorDocumentExpire.LicenseExpiration:
        updatedVendor.licenseExpiration = undefined;
        break;
      default:
        break;
    }
    this.props.onSaveClick(this.props.fileId, updatedVendor);
  };

  renderHideSave() {
    if (this.props.isModal) {
      return (
        <div className="col-md-12">
          <div className="row end-xs">
            <button className="btn btn-hidden" type="button" ref={this.props.buttonRef} onClick={this.onSaveClick}>
              Save
            </button>
          </div>
        </div>
      );
    }
    return (
      <div className="col-md-12">
        <div className="row end-xs mt-10 mb-10">
          <button className="btn btn-primary" type="button" ref={this.props.buttonRef}>
            Save
          </button>
        </div>
      </div>
    );
  }
  render() {
    return (
      <>
        <div className="row middle-xs center-xs">
          <h2>Are you sure you want to remove file: {this.props.filename}</h2>
        </div>
        <div className="row">{this.renderHideSave()}</div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/file-upload/_components/file-remove.component.tsx